import { AppBarProps } from '@mui/material';

import StyledStack from '@webclient/layouts/components/header-wrapper/styles';
import { StyledAppBar, StyledToolbar } from '@webclient/layouts/styles';

export default function HeaderWrapper({
  children,
  position = 'sticky',
}: React.PropsWithChildren<{
  position?: AppBarProps['position'];
}>) {
  return (
    <StyledAppBar
      position={position}
      sx={{ backdropFilter: position === 'fixed' ? '' : 'blur(2px)' }}
    >
      <StyledStack>
        <StyledToolbar component="nav">{children}</StyledToolbar>
      </StyledStack>
    </StyledAppBar>
  );
}
